/**
 * Mirror a value, but only after it has stopped changing for `delay` ms.
 *
 * The search boxes required Enter to apply, because every keystroke otherwise
 * became a request. Enter-to-search is the wrong trade: nobody discovers it,
 * and the field looks broken until you press it. Debouncing gives search-as-
 * you-type at one request per pause instead of one per character.
 */
import { useEffect, useState } from 'react';

export function use_debounced_value<T>(value: T, delay = 350): T {
  const [debounced, set_debounced] = useState(value);

  useEffect(() => {
    const t = setTimeout(() => set_debounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);

  return debounced;
}
